import React, {Component} from "react";
import {Link} from "react-router-dom";
import Constent from '../../networking/Constent';
import {post} from './../../networking/Api'
import {Alert} from "./../../alertServices";
import helpers from './../../networking/Helpers';
import { createHashHistory } from 'history';
import { withTranslation } from 'react-i18next';

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/placeholder.png';
const history = createHashHistory()
class Navbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
          user_id: '',
          name:'',
          last_name:'',
          employee_id:'',
          created_at:'',
          username:'',
          is_pin: false,
          is_password: false,
          password:'',
          user_type_id: '',

          email:'',
          phone:'',
          alternate_number:'',
          address:'',
          city:'',
          zip:'',
          job_title:'',
          birthday:'',
          employee_date:'',
          employee_end_date:'',
          hourly_rate:'',
          total_week_hour:'',
          salary_number:'',
          personal_id_number:'',
          gender:'',
          monthly_salary:'',
          bank_branch_number:'',
          bank_account_number:'',


          department:'',
          department_id:'',
          company:'',
          language:'',
          is_language_chang:false,
          pin:'',
          profile_image:"",
          employement_contract:"",
          employement_contract_link:dummyImage,
          contractUploadfile:"",
          userType:'',
          newFinger : false,

          show_dashboard : 0,
          isFinger : false,
          is_face_image : 0,
          checkin_with : '',
          is_autopunchout : 0,
          images: [],
          department_list: []
        }

        this.handleChangeFile = this.handleChangeFile.bind(this);
    }
    componentDidMount(){
        let is_user_login = localStorage.getItem('is_user_login');
        if(is_user_login !== 'true'){
            history.push('/pin-verification')
        }

        this.setState({
            user_id : localStorage.getItem('userid'),
            profile_image: (localStorage.getItem('user_data') === null) ? dummyImage : JSON.parse(localStorage.getItem('user_data')).profile_image ,
            name : (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).name,
            last_name : (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).last_name,
            username: (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).username
        });


        let departmentId = localStorage.getItem('department_id');
        let department_list= localStorage.getItem('department_list');
        this.setState({ 
            department_list:JSON.parse(department_list),
            department_id : departmentId
        });

      //  this.getProfile();
    }

    selectDepartment = (val, message, btntext) => {
        this.setState({department_id:val});
        Alert.confirm({
            position:'toast-top-full-width',
            message: message,
            btn_yes: btntext,
            action: () =>{
                this.handleChangeDepartment(val)
            }
        })
    };

    handleChangeDepartment = (depId) => {
        var formData=new FormData();
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("department_id",depId)
        post(Constent.CHANGEDEPARTMENT,formData).then(response=>{
          if(response.status===1){
            this.setState({ department_id: depId });
            localStorage.setItem('department_id',this.state.department_id);
            localStorage.setItem('department_name',response.department_name);
            localStorage.setItem('menu_permission', JSON.stringify(response.menu_permission));
            localStorage.setItem('timestamp_option',JSON.stringify(response.timestamp_option));
            Alert.success({title: response.message});
            document.getElementById('logout-btn').click(); 
          }else{
            Alert.error({title: response.message});
          }
        })
    };

    handleChangeFile(event) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            //console.log(files[i])
              //formData.append(`images[${i}]`, files[i])
        }
        this.setState({contractUploadfile:files});
    };

    getProfile(){
    var formdata=new FormData();
    formdata.append("user_id",localStorage.getItem('userid'));
    post(Constent.GETPROFILE,formdata).then(response =>{
    if(response.status===1){
        var str= response.data.employee_date;
            str= str.split("-"); //convert 'jQuery' to array
            str = str.reverse(); //reverse 'jQuery' order 
            str = str.join("-");
        var strs=response.data.employee_end_date;
            strs= strs.split("-"); //convert 'jQuery' to array
            strs = strs.reverse(); //reverse 'jQuery' order 
            strs = strs.join("-");
        var birthday=response.data.birthday;
            birthday= birthday.split("-"); //convert 'jQuery' to array
            birthday = birthday.reverse(); //reverse 'jQuery' order 
            birthday = birthday.join("-");

        this.setState({name:response.data.name,
          last_name:response.data.last_name,
          employee_id:response.data.employee_id,
          created_at:response.data.created_at,
          username:response.data.username,
          is_password:response.data.is_password,
          is_pin:response.data.is_pin_available,

          email:response.data.email,
          phone:response.data.phone_no,
          alternate_number:response.data.alternate_number,
          address:response.data.address,
          city:response.data.city,
          zip:response.data.zip,
          user_type_id:response.data.user_type_id,

          job_title:response.data.job_title,
          birthday:birthday,
          employee_date: str,
          employee_end_date:strs,
          hourly_rate:response.data.hourly_rate,
          total_week_hour:response.data.total_week_hour,
          salary_number:response.data.salary_number,
          personal_id_number:response.data.pin_number,
          gender:response.data.gender,

          monthly_salary:response.data.monthly_salary,
          bank_branch_number:response.data.bank_branch_number,
          bank_account_number:response.data.bank_account_number,

          department:response.data.department_name,
          company:response.data.company_name,
          language:response.data.default_language,
          profile_image:response.data.profile_image,
          employement_contract:response.data.employement_contract,
          employement_contract_link:response.data.employement_contract_link,

          show_dashboard:response.data.show_dashboard,
          isFinger:response.data.is_finger_available,
          is_face_image:response.data.is_face_image,
          checkin_with:response.data.checkin_with,
          is_autopunchout:response.data.is_autopunchout,

        })  
      }
    })
  }

    updateProfile(){
        var str= this.state.employee_date;
            str= str.split("-"); //convert 'jQuery' to array
            str = str.reverse(); //reverse 'jQuery' order 
            str = str.join("-");
        var strs= this.state.employee_end_date;
            strs= strs.split("-"); //convert 'jQuery' to array
            strs = strs.reverse(); //reverse 'jQuery' order 
            strs = strs.join("-");
        var birthday= this.state.birthday;
            birthday= birthday.split("-"); //convert 'jQuery' to array
            birthday = birthday.reverse(); //reverse 'jQuery' order 
            birthday = birthday.join("-");   

        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }  
        var formdata=new FormData();
        formdata.append("user_id",localStorage.getItem('userid'));
        formdata.append("name",this.state.name);
        formdata.append("last_name",this.state.last_name);
        formdata.append("employee_id",this.state.employee_id);
        formdata.append("password",this.state.password);
        formdata.append("login_pin",this.state.pin);
        formdata.append("pin_number",this.state.personal_id_number);
        
        formdata.append("user_type_id",this.state.user_type_id);
        formdata.append("email",this.state.email);
        formdata.append("phone_no",this.state.phone);
        formdata.append("alternate_number",this.state.alternate_number);
        formdata.append("address",this.state.address);
        formdata.append("city",this.state.city);
        formdata.append("zip",this.state.zip);

        formdata.append("job_title",this.state.job_title);
        formdata.append("employee_date",str);
        formdata.append("employee_end_date",strs);
        formdata.append("hourly_rate",this.state.hourly_rate);
        formdata.append("salary_number",this.state.salary_number);
        formdata.append("total_week_hour",this.state.total_week_hour);

        formdata.append("monthly_salary",this.state.monthly_salary);
        formdata.append("bank_branch_number",this.state.bank_branch_number);
        formdata.append("bank_account_number",this.state.bank_account_number);

        formdata.append("birthday",birthday);
        formdata.append("personal_id_number",this.state.personal_id_number);
        formdata.append("gender",this.state.gender);

        formdata.append("image",this.state.pictures);
        formdata.append("language",this.state.language);
        formdata.append("remove_finger",this.state.newFinger);

        formdata.append("show_dashboard",this.state.show_dashboard);
        formdata.append("auth_fingerprint_data",this.state.isFinger);
        formdata.append("remove_finger",this.state.is_face_image);
        formdata.append("checkin_with",this.state.checkin_with);
        formdata.append("stop_autopunchout",this.state.is_autopunchout);

        const files = this.state.contractUploadfile;
        for (let i = 0; i < files.length; i++) {
            formdata.append(`employement_contract`, files[i])
        }

        post(Constent.UPDATEPROFILE,formdata,config).then(response =>{
          if(response.status===1){
            window['modalClose']();
            Alert.success({title: response.message});
            
            if(this.state.contractUploadfile.length > 0){
                this.getProfile();
            }
            if(this.state.is_language_chang){
                this.changeLanguage(this.state.language);
            }
            if(this.state.newFinger === true){
              this.setState({isFinger:false});
            }
          }else{
            if(response.errors.employee_id){
              Alert.error({title: response.errors.employee_id});
            }else{
              Alert.error({title: response.message});
            }
          }
        })
      }

    logoutUser(){
        localStorage.setItem('is_user_login',false);
       // localStorage.setItem('userid',null);
       // localStorage.setItem('user_data',null);
    }  

    changeLanguage(lng){
        localStorage.setItem('defaultLng',lng);
        if( (lng === 'en') || (lng === 'English')) {
            lng = 'en';
        }else if( (lng === 'dk') || (lng === 'Danish') ){
            lng = 'dk';
        }else if( (lng === 'fr') || (lng === 'French') ){
            lng = 'fr';
        }else if( (lng === 'tr') || (lng === 'TR') ){
            lng = 'tr';
        }else if( (lng === 'hi') || (lng=== 'Hindi') ){
            lng = 'hi';
        }else{
            lng = 'dk';
        }                           
       const {  i18n } = this.props;
       i18n.changeLanguage(lng);
       localStorage.setItem('lng',lng);
    }
    render() {
        const { t } = this.props;
        return (
            <>
            <div className="ba-navbar">
                <div className="ba-navbar-user">
                    <div className="menu-close">
                        <i className="la la-times" />
                    </div>
                    <div className="thumb">
                        <Link to={'/'}>
                        <div className="header-user">
                            <img src={ this.state.profile_image } alt="user" />
                        </div>
                        </Link>
                    </div>
                    <div className="details">
                        <Link to={'/'}>
                        <h5 className="text-overflow" style={{margin:0}}>{this.state.name} {this.state.last_name}</h5>
                        <p>{this.state.username}</p>
                        </Link>
                    </div>
                </div>
                <div className="ba-main-menu">
                    <ul>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#basic-modal">{t('lang.navigation_sc_basic')}</Link></li>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#access-modal">
                            {t('lang.navigation_sc_access')}</Link></li>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#contact-modal">{t('lang.navigation_sc_contact')}</Link></li>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#job-modal">{t('lang.navigation_sc_job_salary')}</Link></li>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#personal-modal">{t('lang.navigation_sc_personal')}</Link></li>
                        <li><Link  onClick={()=>{this.getProfile()}} to={'#'} data-toggle="modal" data-target="#rule-modal">{t('lang.navigation_sc_rullers')}</Link></li>
                    </ul>
                    <Link to={'/pin-verification'} className="btn btn-red" id="logout-btn" onClick={()=>{this.logoutUser()}}>{t('lang.navigation_sc_logout')}</Link>
                </div>
            </div>



            {/* basic-modal start */}
            <div id="basic-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.navigation_sc_basic_details')}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.employee_sc_name')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.name} 
                                    onChange={e => { this.setState({name: e.target.value})}}/>
                                </div>
                            
                                <span className="label">{t('lang.employee_sc_surname')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.last_name} 
                                    onChange={e => { this.setState({last_name: e.target.value})}} />
                                </div>
                        
                                <span className="label">{t('lang.employee_sc_employee_id')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.employee_id} readOnly={true}/>
                                </div>

                                <span className="label">{t('lang.employee_sc_registration_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.created_at} readOnly={true}/>
                                </div>

                                {(localStorage.getItem('user_type') !== 'user') ?
                                <>
                                <span className="label">{t('lang.employee_sc_move_to_other_department')}</span>
                                <div className="input-group mb-4">
                                    <select className="form-control form-control-lg" value={this.state.department_id}
                                      onChange={e => { this.selectDepartment(e.target.value, t('lang.message_are_you_sure'), t('lang.btn_text_yes_do_it') )}}>
                                      <option>{t('lang.employee_sc_select_department')}</option>
                                      { this.state.department_list.map(({ department_id, department_name}) => (
                                      <option value={department_id} key={department_id}>{department_name}</option>
                                      ))}
                                    </select>
                                </div></> : ''}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close') }</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save') }</button>
                        </div>
                    </div>
                </div>
            </div>


        {/* access-modal start */}
            <div id="access-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_access_details') }</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                        <form>
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.employee_sc_username') }</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.username}  readOnly={true} />
                                </div>
                            
                                <span className="label">{t('lang.employee_sc_password') }</span>
                                <div className="input-group mb-4">
                                    <input type="password" className="form-control form-control-lg"
                                    placeholder={(this.state.is_password === true ? '******' : t('lang.employee_sc_enter_password') )}
                                    onChange={e => { this.setState({password: e.target.value})}} autoComplete='false' />
                                </div>
                        
                                <span className="label">{ t('lang.employee_sc_pin') }</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg" defaultValue={this.state.pin}
                                    placeholder={(this.state.is_pin === true ? '****' : t('lang.employee_sc_enter_pin') )}
                                    onChange={e => { this.setState({pin: e.target.value})}} />
                                </div>

                                {(localStorage.getItem('user_type') !== 'user') ?
                                <>
                                <span className="label">{t('lang.employee_sc_role')}</span>
                                <div className="input-group mb-4">
                                    <select className="form-control form-control-lg" value={this.state.user_type_id}
                                      onChange={e => { this.setState({user_type_id: e.target.value})}}>
                                      <option>{t('lang.employee_sc_select_role')}</option>
                                      <option value="1">{t('lang.employee_sc_user')}</option>
                                      <option value="2">{t('lang.employee_sc_department_head')}</option>
                                      <option value="4">{t('lang.employee_sc_guest')}</option>
                                    </select>
                                </div> </>
                                : ''}
                            </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

        {/* contact-modal start */}
            <div id="contact-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_contact_details')}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.employee_sc_email')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.email} 
                                    onChange={e => { this.setState({email: e.target.value})}}  />
                                </div>
                            
                                <span className="label">{t('lang.employee_sc_phone')}</span>
                                <div className="input-group mb-4">
                                    <input type="number" className="form-control form-control-lg"
                                    defaultValue={this.state.phone} 
                                    onChange={e => { this.setState({phone: e.target.value})}} />
                                </div>
                        
                                <span className="label">{t('lang.employee_sc_alternate_number')}</span>
                                <div className="input-group mb-4">
                                    <input type="number" className="form-control form-control-lg"
                                    defaultValue={this.state.alternate_number}  
                                    onChange={e => { this.setState({alternate_number: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_address')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.address}  
                                    onChange={e => { this.setState({address: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_city')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.city}  
                                    onChange={e => { this.setState({city: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_zip')}</span>
                                <div className="input-group mb-4">
                                    <input type="number" className="form-control form-control-lg"
                                    defaultValue={this.state.zip}  
                                    onChange={e => { this.setState({zip: e.target.value})}} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>


        {/* Job/Salary-modal start */}
            <div id="job-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_job_salary_details')}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                                <span className="label">{t('lang.employee_sc_job_title')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.job_title} 
                                    onChange={e => { this.setState({job_title: e.target.value})}}  />
                                </div>
                          
                                <span className="label">{t('lang.employee_sc_employee_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    defaultValue={this.state.employee_date} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({employee_date: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_employee_end_date')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    defaultValue={this.state.employee_end_date} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({employee_end_date: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_hourly_rate')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.hourly_rate} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({hourly_rate: e.target.value})}} />
                                </div>
                                
                                <span className="label">{t('lang.employee_sc_total_week_hour')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.total_week_hour} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({total_week_hour: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_salary_number')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.salary_number} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({salary_number: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_monthly_salary')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.monthly_salary} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({monthly_salary: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_registration_number')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.bank_branch_number} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({bank_branch_number: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_account_number')}</span>
                                <div className="input-group mb-4">
                                    <input type="number" className="form-control form-control-lg"
                                    defaultValue={this.state.bank_account_number} 
                                    readOnly={ (localStorage.getItem('user_type') !== 'user') ? false : true }
                                    onChange={e => { this.setState({bank_account_number: e.target.value})}} />
                                </div>                              
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  personal-modal start */}
            <div id="personal-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_personal_details')}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="action-sheet-content">
                               
                                <span className="label">{t('lang.employee_sc_birthday')}</span>
                                <div className="input-group mb-4">
                                    <input type="date" className="form-control form-control-lg"
                                    defaultValue={this.state.birthday} 
                                    max={helpers.getCurrentDate()}
                                    onChange={e => { this.setState({birthday: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_personal_id_number')}</span>
                                <div className="input-group mb-4">
                                    <input type="text" className="form-control form-control-lg"
                                    defaultValue={this.state.personal_id_number} 
                                    onChange={e => { this.setState({personal_id_number: e.target.value})}} />
                                </div>

                                <span className="label">{t('lang.employee_sc_gender')}</span>
                                <div className="input-group mb-4">
                                    <select className="form-control form-control-lg" value={this.state.gender}
                                      onChange={e => { this.setState({gender: e.target.value})}}>
                                      <option>{t('lang.employee_sc_select_gender')}</option>
                                      <option value="Male">{t('lang.employee_sc_male')}</option>
                                      <option value="Female">{t('lang.employee_sc_female')}</option>
                                    </select>
                                </div>

                                <span className="label">{t('lang.employee_sc_language')}</span>
                                <div className="input-group mb-4">
                                    <select className="form-control form-control-lg" value={this.state.language}
                                      onChange={e => { this.setState({language: e.target.value, is_language_chang:true})}}>
                                      <option>{t('lang.employee_sc_select_language')}</option>
                                      <option value="Danish">{t('lang.language_text_danish')}</option>
                                      <option value="English">{t('lang.language_text_english')}</option>
                                      <option value="French">{t('lang.language_text_french')}</option>
                                      <option value="TR">{t('lang.language_text_tr')}</option>
                                    </select>
                                </div>
                                
                                {(localStorage.getItem('user_type') !== 'user') ?
                                <>
                                <span className="label">{t('lang.employee_sc_employement_contract')}</span>
                                <div className="input-group mb-4">
                                    <input type="file" className="form-control form-control-lg" onChange={this.handleChangeFile}/>
                                </div>
                                <div className="text-right">
                                    <Link to={'/'} className="link" data-toggle="modal" data-target="#iframe-modal">
                                    {this.state.employement_contract}</Link></div>
                                </> : ''}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>

            {/*  iframe-modal start */}
            <div id="iframe-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_employement_contract')}</h5>
                            <div className="modal-close" data-dismiss="modal">
                                <i className="la la-times" />
                            </div>
                        </div>
                        <div className="modal-body" style={{'height':'80vh'}}>
                            <iframe title="contract" src={this.state.employement_contract_link} style={{'width':'100%','height':'80vh'}} />
                        </div>
                    </div>
                </div>
            </div> 

            {/*  rule-modal start */}
            <div id="rule-modal" className="modal fade">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{t('lang.employee_sc_rule_details')}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <i className="las la-times-circle"></i>
                                <span className="sr-only">close</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <ul className="transaction-details-inner">   
                                {(localStorage.getItem('user_type') !== 'user') ?
                                <li>
                                <span className="label">{t('lang.employee_sc_show_in_dashboard__face_stamp')}</span>
                                <span className="float-right">
                                    <span className="single-switch">
                                        <label className="switch">
                                            <input type="checkbox" />
                                            <span className="slider round" />
                                        </label>
                                    </span>
                                </span>
                                </li> : ''}
                                <li>
                                    <span className="label"> {this.state.isFinger === true ? t('lang.employee_sc_remove_finger') : t('lang.employee_sc_no_fingerprint_found') }</span>
                                    <span className="float-right">
                                        <span className="single-switch">
                                            <label className="switch">
                                                <input type="checkbox" 
                                                value="1"
                                                checked={this.state.isFinger}
                                                onChange={e => { this.setState({isFinger: e.target.checked})}} 
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                    </span>
                                </li>

                                <li>
                                    <span className="label"> {this.state.is_face_image === 1 ? t('lang.employee_sc_remove_face_image') : t('lang.employee_sc_no_face_image_found') }</span>
                                    <span className="float-right">
                                        <span className="single-switch">
                                            <label className="switch">
                                                <input type="checkbox" 
                                                value="1"
                                                checked={this.state.is_face_image}
                                                onChange={e => { this.setState({is_face_image: e.target.checked})}} 
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                    </span>
                                </li>
                                {(localStorage.getItem('user_type') !== 'user') ?
                                <><li>
                                    <span className="label">{ (this.state.checkin_with === 'face') ? t('lang.employee_sc_checkin_with_face')  : '' } { (this.state.checkin_with === 'pin') ? t('lang.employee_sc_checkin_with_pin') : '' }</span>
                                    <span className="float-right">
                                        <span className="single-switch">
                                            <label className="switch">
                                                <input type="checkbox" 
                                                value="1"
                                                checked={ (this.state.checkin_with === 'pin') ? true : false }
                                                onChange={e => { this.setState({checkin_with: e.target.checked})}} 
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                    </span>
                                </li>
                                <li>
                                    <span className="label">{t('lang.employee_sc_stop_autopunchout_16_hrs')}</span>
                                    <span className="float-right">
                                        <span className="single-switch">
                                            <label className="switch">
                                                <input type="checkbox" 
                                                value="1"
                                                checked={this.state.is_autopunchout}
                                                onChange={e => { this.setState({is_autopunchout: e.target.checked})}} 
                                                />
                                                <span className="slider round" />
                                            </label>
                                        </span>
                                    </span>
                                </li></>
                                :'' }
                            </ul>
                           
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-shadow" data-dismiss="modal">{t('lang.modal_btn_close')}</button>
                            <button type="button" className="btn btn-primary" onClick={()=>{this.updateProfile()}}>{t('lang.modal_btn_save')}</button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default (withTranslation('common')(Navbar));